import apiClient from "../../../../services/apiClient"

import statuses from "../data/statuses";


/**
 * 
 * @param {*} idArr
 * 
        "garten_pdo_id": "58b3597eabd93dbbf97db254",
		"garten_name": "Заклад дошкільної освіти 130",
		"institution_type": "дитячий садочок",
		"edrpou_code": "33887748",
		"garten_number": "130",
		"property_type": "комунальна",
		"principal_full_name": " Кибукевич Марина Петрівна",
		"address_auxiliary": "м. Київ, вул. Білоруська, буд. 15-а",
		"has_room_gym": false,
		"has_room_musical": false,
		"address_email": "dnz130@ukr.net",
		"address_phone": "(044)483-73-94; 073 151-01-09",
		"address_web": "ні",
		"time_opens": "1970-01-01T04:00:00.000Z",
		"time_closed": "1970-01-01T16:00:00.000Z",
		"comments": "немає",
		"address_longitude": 30.47598439999999,
		"address_latitude": 50.4637146 
 */


async function getKgInfo(arrReq){


    const arr_kgs = [];

    for(const req of arrReq){
        const {criterias} = req;
        for(const cr of criterias){
            if(cr.values) arr_kgs.push(...cr.values);
        }
    };


    const strArr = [...new Set(arr_kgs)].map(idK=>`kg_id=${idK}`).join("&");

    const url = `kgs_info?${strArr}`;

    const res = await apiClient.get(url);

    return res.data || [];

}


async function transformRequests(data){

    const info_arr ={
        active: [],
        inkg:[],
        rm:[],
        raw:{}
    }

    const kg_info = await getKgInfo(data);

    const getDescKg = (id_kg)=>{

        const desc = kg_info.find(k=>k.garten_pdo_id == id_kg);

        if(!desc) return ({});

        return ({
                        name: [desc.garten_number, desc.garten_name].join(" "),
                        address: desc.address_auxiliary,
                        _id: id_kg
                });

    }


    for(const d of data){

        info_arr.raw[d._id] = d;

        const { child, criterias, preferDateFrom, queueNumber, invite, currentStatus, specialization } = d;
        const { birthCertificate } = child;

        const getDeclShow = ()=>{
                const decl_st_arr = d.statuses.filter(s=>s.name == 'invite-declined').filter(s=>(new Date().getTime() < (new Date(s.date).getTime() + 24*60*60*1000) ));
                return decl_st_arr.length > 0;
            }

        const info = {
            id: d._id,
            childName: child.firstName,
            status: d.currentStatus.name,
            applicationNumber: `Заявка  ${d.registrationNumber} від ${new Date(d.createdAt).toLocaleDateString('uk') }`,
            canEdit: statuses.canAdd.includes(d.currentStatus.name),
            birthCertificate: {
                seriesNumber: birthCertificate.number,
                issueDate: new Date(birthCertificate.issueDate).toLocaleDateString('uk')
            },
            childFullName: `${child.firstName} ${child.middleName || ''} ${child.lastName || ''}`,
            birthDate:  new Date(child.birthDate).toLocaleDateString('uk') ,
            registrationInfo: {
                text: "Реєстрація не підтверджена",
                date: ""
            },
            cardStatus: {
                text: "Картка киянина не підтверджена",
                confirmed: false,
                canAddData: statuses.canAdd.includes(d.currentStatus.name)
            },
            child,
            preferDateFrom,
            queueNumber,
            invite,
            currentStatus,
            specialization,
            isDeclinedShow: getDeclShow()
        };

        for(const cr of criterias){
            if(cr.key == 'kindergartenId') {
                info['selectedKindergartens'] = {
                    count: cr.values.length,
                    list: cr.values.map(v=>getDescKg(v))
                }
            }
        }

        info_arr.active.push(info);

        
    }

    return info_arr;
};


function sortKg(a,b){
    const a_date = new Date(a.createdAt).getTime();
    const b_date = new Date(b.createdAt).getTime();

    if(a_date > b_date) return -1;
    if(a_date < b_date) return 1;
    return 0;
}



export async function getRequests(statuses){

    const url = `requests/user_info?with_statuses=${statuses.join(",")}`

    const result = await apiClient.get(url);

    return transformRequests(result.data.sort(sortKg));

}

export async function removeApplication(id){

    if(!id) return null;

    const url = `requests/${id}/mark_as_removed`;

    const result = await apiClient.post(url);

    return result;
}

export async function getRepitApplicationInfo({birthCertificate}){
    
    if(!birthCertificate) return null;

    const url = `requests/check_repit`;

    const result = await apiClient.post(url, {bcnumber: birthCertificate});

    return result;
}